import ContentHelp from '@flatsy/core/Content/Help'
import { Body2 } from '@flatsy/core/MaterialUi/Typo'
import { formatPhoneNumber } from '@flatsy/utils/Functions/format/PhoneNumber'
import i18n from '@flatsy/utils/translations'
import React from 'react'
import { useApplicationBooking } from 'src/hooks/ApplicationBooking'
import { useStyles } from './Style'
import { UpdateBookingInformationProps } from './Type'

const UpdateBookingInformation: React.FC<UpdateBookingInformationProps> = ({
  application,
}): React.ReactElement => {
  const classes = useStyles()
  const { booking } = useApplicationBooking({ applicationId: application.id })

  const renderPhoneNumber = () => {
    if (booking) {
      return formatPhoneNumber(booking.agent.phone_number)
    }

    return (
      application &&
      application.agent &&
      application.agent.phone_number &&
      formatPhoneNumber(application?.agent?.phone_number)
    )
  }

  return (
    <ContentHelp className={classes.helper}>
      <div className={classes.sideBorder} />
      <div>
        <Body2>
          {i18n.t('rescheduling_is_only_possible_by_contacting_your_agent')}
          <br />
          <strong className={classes.helperAgentName}>
            {booking ? booking?.agent?.first_name : application?.agent?.first_name}
          </strong>{' '}
          {i18n.t('at').toLowerCase()} <strong>{renderPhoneNumber()}</strong>
        </Body2>
      </div>
    </ContentHelp>
  )
}

export default UpdateBookingInformation
